
// @ts-nocheck


import { Component, Prop, Vue } from 'vue-property-decorator';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
import { ClientsStore } from "@/store/modules/Clients";
import {WorkersStore} from "@/store/modules/Workers";

import { IClients, IClientsListItem } from "@/entity/clients/clients.types";
import {IWorkers, IWorkersListItem} from "@/entity/workers/workers.types";

import VisitGeneralForm from "@/form/visits/visitGeneral";
import VisitCreateForm from "@/form/visits/visitCreate";

import {ServiceStore} from "@/store/modules/Services";
import {IServices, IServicesListItem} from "@/entity/services/services.types";

import {ServicesCategoryStore} from "@/store/modules/ServicesCategory";
import { IServicesCategory, IServicesCategoryListItem } from "@/entity/servicesCategory/services.category.types";

import VisitServiceMultyDetail from "@/UI/components/forms/visits/detail/VisitServiceMultyDetail.vue";

import { SourcesStore } from '@/store/modules/Sources';
import { ISources } from '@/entity/sources/sources.types';

import moment from 'moment';
import {message} from "ant-design-vue";


@Component({
    components: { FormGroup, VisitServiceMultyDetail},
    methods: { moment }
})
export default class VisitDetailMain extends Vue {
    @Prop() form!: VisitGeneralForm;
    curr_client: IClientsListItem | undefined;
    curr_client_visits_count: number = 0;
    last_visit_date: string = '';
    
    cosmetologist_fio: any | undefined;

        handleTimeToDate(time: any) {
            console.clear();
            console.log(time.format('YYYY-MM-DD'));
            console.log('date');
            this.form.visit_date = time.format('YYYY-MM-DD');
        }

        handleTimeToDateTime(time: any) {
            console.clear();
            this.form.visit_date_time_start = time.format('HH:mm');
            this.handleDiffTime(this.form.visit_date_time_end, time);
        }

        handleTimeEndToDateTime(time:any){
            this.form.visit_date_time_end = time.format('HH:mm');
            this.handleDiffTime(time, this.form.visit_date_time_start);
        }


        handleDiffTime(time_end: any, time_start: any){
            let diff = moment.utc(moment(time_end).diff(moment(time_start, 'HH:mm'))).format('HH:mm');
            this.form.visit_duration = diff;
        }


        setStatus(key:any){
            if(!this.disabled) {
                this.form.status_id = Number(key);
                this.status = Number(key);
                this.$emit('status-change', Number(key));
            }
        }

        handleTimeChange(value: any): void {
            this.form.visit_duration = value.format('HH:mm');
        }

        
        get service(): IServices | null {
            return ServiceStore.service;
        }

        get servicesCategory(): IServicesCategory | null {
            return ServicesCategoryStore.serviceCategory;
        }

        get clients(): IClients | null {
            return ClientsStore.clients;
        }

        get staff(): IWorkers | null {
          return WorkersStore.workers;
        }

        get sourceArray(): ISources[] {
            return SourcesStore.sources;
        }
        
        
        async created(): Promise<void> {
            await SourcesStore.fetchAll();
            await ClientsStore.fetchAll({limit: 10});
            this.curr_client = this.clients?.data.find(e => e.id == this.form.client_id);
            // this.curr_client_visits_count = this.curr_client.visits.length;
            // if(this.curr_client !== undefined && this.curr_client !== null)
            // {
            //     let dt = this.last_visit_date = this.curr_client.visits.pop().visit_dt;
            // }
           
            console.log('curr client');
            console.log(this.form.client_last_visit_date);
            console.log(this.form.created_date);

            // await ServicesCategoryStore.fetchAll({limit: 20});
            await ServiceStore.fetchAll({filter: {salon_id: this.form.salon_id}});
            this.cosmetologist_fio = WorkersStore.workers?.data.find(el => el.id == this.form.cosmetologists_id)!.fio ?? 0;
            console.log(this.cosmetologist_fio);
        }
}
